// extracted by mini-css-extract-plugin
export default {"postPage":"i2Ykc0","wrapper":"FoZ96Q","emptyState":"odmeSA","aboveContentSlot":"J8gM82","pageBottomSlot":"YkO9W6","mobileContainer":"hcAZy2"};